import React from 'react';
class DetectBrowser extends React.Component{

    render(){

        // Internet Explorer 6-11
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        console.log(isIE);
        if(isIE) {
            return (
                <div>Currently there is a problem opening this website in Internet explorer.Please use another browser to perform test.</div>
            );
        }else{
            console.log('other browser');
            return (
                <div></div>
            );
        }
    }
}
export default DetectBrowser;
